export default __webpack_public_path__ + "static/media/lock.e0fbaec6.svg";